export default "__VITE_ASSET__B5KR$Ois__"